import { useState } from "react";

import Image from "next/image";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import { UserPhotoLeftStarsIcon } from "shared/components/molecules/Gamification/assets/icons/UserPhotoLeftStarsIcon";
import { UserPhotoRightStarsIcon } from "shared/components/molecules/Gamification/assets/icons/UserPhotoRightStarsIcon";

import {
  CircularProgress,
  GamificationModalUserPhotoContainer,
} from "./styles";

interface IGamificationModalUserPhotoProps {
  photoSrc: string;
  fullName: string;
  circularProgressRate?: number;
  withStars?: boolean;
}

export const GamificationModalUserPhoto = ({
  photoSrc = "",
  circularProgressRate,
  fullName,
  withStars = false,
}: IGamificationModalUserPhotoProps) => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  const hasImageToShow = !!photoSrc && !imageFailedToLoad;

  return (
    <GamificationModalUserPhotoContainer>
      <div className="user-photo">
        {!!circularProgressRate && (
          <CircularProgress progressRate={circularProgressRate}>
            <svg
              width="110"
              height="110"
              viewBox="0 0 110 110"
              className="circular-progress"
            >
              <circle className="bg"></circle>
              <circle className="fg"></circle>
            </svg>
          </CircularProgress>
        )}

        <div className="user-info">
          {withStars && <UserPhotoLeftStarsIcon />}
          {!!hasImageToShow ? (
            <ComponentErrorBoundary>
              <Image
                src={photoSrc}
                alt=""
                width={88}
                height={88}
                onError={() => setImageFailedToLoad(true)}
              />
            </ComponentErrorBoundary>
          ) : (
            <SimpleUserInitialsName fullName={fullName} />
          )}
          {withStars && <UserPhotoRightStarsIcon />}
        </div>
      </div>
    </GamificationModalUserPhotoContainer>
  );
};
